import { render, staticRenderFns } from "./PraxisSelect.vue?vue&type=template&id=df8859a4"
import script from "./PraxisSelect.vue?vue&type=script&lang=js"
export * from "./PraxisSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports